// Generated from config/canonical-contract.json. Do not edit directly.
const policy = {
  "version": 1,
  "base": [
    "id",
    "name",
    "lat",
    "lng",
    "address",
    "google_place_id",
    "state",
    "status",
    "style",
    "price",
    "rating"
  ],
  "pizza": {
    "map": [
      "id",
      "name",
      "lat",
      "lng",
      "address",
      "google_place_id",
      "state",
      "status",
      "style",
      "price",
      "rating",
      "website_url",
      "menu_url",
      "phone",
      "hours",
      "price_range",
      "brand",
      "operator",
      "lifecycle_status",
      "lifecycle_replaced_by_id"
    ],
    "detail": [
      "id",
      "name",
      "lat",
      "lng",
      "address",
      "google_place_id",
      "state",
      "status",
      "style",
      "price",
      "rating",
      "website_url",
      "menu_url",
      "phone",
      "hours",
      "price_range",
      "brand",
      "operator",
      "lifecycle_status",
      "lifecycle_replaced_by_id"
    ],
    "legacy_map": [
      "id",
      "name",
      "lat",
      "lng",
      "address",
      "google_place_id",
      "state",
      "status",
      "style",
      "price",
      "rating",
      "website_url",
      "phone",
      "price_range",
      "brand",
      "operator"
    ],
    "legacy_detail": [
      "id",
      "name",
      "lat",
      "lng",
      "address",
      "google_place_id",
      "state",
      "status",
      "style",
      "price",
      "rating",
      "website_url",
      "phone",
      "price_range",
      "brand",
      "operator"
    ]
  },
  "taco": {
    "map": [
      "id",
      "name",
      "lat",
      "lng",
      "address",
      "google_place_id",
      "state",
      "status",
      "style",
      "price",
      "rating",
      "website_url",
      "menu_url",
      "phone",
      "hours",
      "price_range",
      "brand",
      "operator",
      "lifecycle_status",
      "lifecycle_replaced_by_id"
    ],
    "detail": [
      "id",
      "name",
      "lat",
      "lng",
      "address",
      "google_place_id",
      "state",
      "status",
      "style",
      "price",
      "rating",
      "website_url",
      "menu_url",
      "phone",
      "hours",
      "price_range",
      "brand",
      "operator",
      "lifecycle_status",
      "lifecycle_replaced_by_id"
    ],
    "legacy_map": [
      "id",
      "name",
      "lat",
      "lng",
      "address",
      "google_place_id",
      "state",
      "status",
      "style",
      "price",
      "rating",
      "website_url",
      "phone",
      "price_range",
      "brand",
      "operator"
    ],
    "legacy_detail": [
      "id",
      "name",
      "lat",
      "lng",
      "address",
      "google_place_id",
      "state",
      "status",
      "style",
      "price",
      "rating",
      "website_url",
      "phone",
      "price_range",
      "brand",
      "operator"
    ]
  }
}

export default policy
